import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../types"
import { Overlay, Box, BoxContent } from "../modal.styled"
import { ModalProps } from "../modal.interface"
import CloseButton from "../../close-button/close-button.component"
import useContentTop from "../../../helpers/content-top/content-top.hook"

const ModalBox = styled(Box)<{ top?: number }>`
  margin: ${({ top }) => (top ? `${top}px` : 0)} 0 0;
  align-items: flex-start;
  justify-content: flex-end;
`

const ContentWrapper = styled(BoxContent)`
  --modal-content-width: calc(100vw - 40px);
  --right-space: 0;
  --horizontal-padding: 20px;

  width: calc(
    var(--modal-content-width) + var(--right-space) + var(--horizontal-padding)
  );
  padding: var(--horizontal-padding);

  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    --modal-content-width: 380px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    --horizontal-padding: 30px;
    padding: 20px var(--horizontal-padding) var(--horizontal-padding);
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    --right-space: calc((100% - 1160px) / 2);
  }
`

const Content = styled.div`
  position: relative;
  width: var(--modal-content-width);
`

const Close = styled(CloseButton)`
  --circle-size: ${32 / 16}rem;
  --icon-size: ${12 / 16}rem;

  position: absolute;
  top: -5px;
  right: 0;
`

const MessageModal: AppFunctionComponent<ModalProps> = ({
  onClose,
  children,
  headerVisible,
}) => {
  const top = headerVisible ? useContentTop() : 0

  return (
    <>
      <Overlay onClick={onClose} data-testid="modal-overlay" />
      <ModalBox top={top}>
        <ContentWrapper data-testid="modal-content-wrapper">
          <Content>
            <Close onClick={onClose} />
            {children}
          </Content>
        </ContentWrapper>
      </ModalBox>
    </>
  )
}

export default MessageModal
